import { configureStore, combineReducers } from '@reduxjs/toolkit';
import onboardingReducer from './slices/onboardingSlice';

const rootReducer = combineReducers({
  onboarding: onboardingReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: true,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 